module.exports = __webpack_public_path__ + "OceanHeart.webp?fe48ad7e20584cba0b9e9dc3bd01fc43";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/OceanHeart.webp
// module id = 148
// module chunks = 0